import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const {
  i18n: {
    __,
  },
} = wp;

export default class ShowMore extends PureComponent {
  /**
   * Set PropTypes for this component.
   *
   * @type {object}
   */
  static propTypes = {
    cssClass: PropTypes.string.isRequired,
    showMore: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
  };

  /**
   * Handle show more click.
   */
  handleClick = () => {
    const { showMore } = this.props;
    showMore();
  };

  render() {
    const {
      cssClass,
      disabled,
    } = this.props;
    return (
      <button
        className={cssClass}
        onClick={this.handleClick}
        type="button"
        disabled={disabled}
      >
        <span className="show-more__text">
          {__('Show More', 'nbc')}
        </span>
      </button>
    );
  }
}
